import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchComplaintStatusAndPriorityFailure, fetchComplaintStatusAndPriorityStart, fetchComplaintStatusAndPrioritySuccess, loadComplaintStatusAndPriorityRequest } from '../complaintStatusAndPrioritySlice';
import { complaintStatusAndPriorityApi } from '../../api/apiLists/complaintStatusAndPriorityApi';
import { callWithAuth } from '../sagaApiHelper';

function* handleFetchComplaintStatusAndPriority(action) {

    try {
        yield put(fetchComplaintStatusAndPriorityStart());
        const res = yield call(callWithAuth, complaintStatusAndPriorityApi, ["en"]);

        const { statusOptions, priorityOptions } = res;

        yield put(fetchComplaintStatusAndPrioritySuccess({
            statusOptions,
            priorityOptions,
        }));
    } catch (error) {
        yield put(fetchComplaintStatusAndPriorityFailure({ error: error.message }));
    }
}

export default function* complaintStatusAndPrioritySaga() {
    yield takeLatest(loadComplaintStatusAndPriorityRequest.type, handleFetchComplaintStatusAndPriority);
}